import React from 'react';

const Success = () => {
  return (
    <div style={styles.wrapper}>
      <div style={styles.card}>
        <h1 style={styles.heading}>🎉 Session Booked Successfully!</h1>
        <p style={styles.message}>Thank you! You’ll receive a confirmation email shortly.</p>
      </div>
    </div>
  );
};

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px 20px',
    background: '#f5f7fa',
    minHeight: '60vh', // 👈 Reduced height
  },
  card: {
    background: '#ffffff',
    padding: '40px 30px',
    borderRadius: '12px',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
  },
  heading: {
    fontSize: '26px',
    color: '#2e7d32',
    marginBottom: '12px',
  },
  message: {
    fontSize: '18px',
    color: '#333',
  },
};

export default Success;
